module.exports = __webpack_public_path__ + "img/RedteaMobile_ picture1 web.7eb9b341.png";